import {Routes} from '@angular/router';
import {needsLoginGuard} from './core/guards/needs-login.guard';
import {HomeComponent} from './features/home/home.component';
import {alreadyLoggedGuard} from './core/guards/already-logged.guard';
import {LoginComponent} from './features/login/login.component';
import {WelcomeComponent} from './features/welcome/welcome.component';
import {RecommendationsComponent} from './features/recommendations/recommendations.component';
import {RecommendationsDetailComponent} from './features/recommendations-detail/recommendations-detail.component';
import {HouseRulesComponent} from './features/house-rules/house-rules.component';
import {HouseRuleDetailComponent} from './features/house-rule-detail/house-rule-detail.component';
import {HowItWorksComponent} from './features/how-it-works/how-it-works.component';
import {HowItWorksDetailComponent} from './features/how-it-works-detail/how-it-works-detail.component';
import {OpenComponent} from './features/open/open.component';
import {PrivacyPolicyComponent} from './features/privacy-policy/privacy-policy.component';
import {TermsAndConditionsComponent} from './features/terms-and-conditions/terms-and-conditions.component';
import {TravelReportComponent} from './features/travel-report/travel-report.component';
import {ContractComponent} from './features/contract/contract.component';
import {CheckInFormComponent} from './features/check-in-form/check-in-form.component';
import {CheckInSignatureComponent} from './features/check-in-signature/check-in-signature.component';
import {CheckInEndComponent} from './features/check-in-end/check-in-end.component';
import {CheckInMrzComponent} from './features/check-in-mrz/check-in-mrz.component';
import {Others1Component} from './features/others-1/others-1.component';
import {Others2Component} from './features/others-2/others-2.component';
import {PlansAndServicesComponent} from './features/plans-and-services/plans-and-services.component';
import {MapComponent} from './features/map/map.component';
import {InfoComponent} from './features/info/info.component';
import {DepositComponent} from './features/deposit/deposit.component';
import {DepositNewCheckInComponent} from './features/deposit-new-check-in/deposit-new-check-in.component';
import {DepositSelectCheckInComponent} from './features/deposit-select-check-in/deposit-select-check-in.component';
import {CheckInSignatureMinorComponent} from './features/check-in-signature-minor/check-in-signature-minor.component';
import {reservationHasPendingCheckInsGuard} from './core/guards/reservation-has-pending-check-ins.guard';
import {reservationHasMinorPendingCheckInsGuard} from './core/guards/reservation-has-minor-pending-check-ins.guard';
import {reservationHasPendingSignedCheckinsGuard} from './core/guards/reservation-has-pending-signed-checkins.guard';
import {
  reservationHasMinorPendingSignedCheckinsGuard
} from './core/guards/reservation-has-minor-pending-signed-checkins.guard';
import {CheckInMinorEndComponent} from './features/check-in-minor-end/check-in-minor-end.component';
import {reservationHasAdultCompletedCheckinsGuard} from './core/guards/reservation-has-adult-completed-check-ins.guard';
import {reservationHasPendingDepositGuard} from './core/guards/reservation-has-pending-deposit.guard';


export const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    canActivate: [needsLoginGuard],
    component: HomeComponent
  },
  {
    path: 'login',
    canActivate: [alreadyLoggedGuard],
    component: LoginComponent
  },
  {
    path: 'welcome',
    canActivate: [needsLoginGuard],
    component: WelcomeComponent
  },
  {
    path: 'recommendations',
    canActivate: [needsLoginGuard],
    component: RecommendationsComponent
  },
  {
    path: 'recommendations/:id',
    canActivate: [needsLoginGuard],
    component: RecommendationsDetailComponent
  },
  {
    path: 'house-rules',
    canActivate: [needsLoginGuard],
    component: HouseRulesComponent
  },
  {
    path: 'house-rules/:id',
    canActivate: [needsLoginGuard],
    component: HouseRuleDetailComponent
  },
  {
    path: 'how-it-works',
    canActivate: [needsLoginGuard],
    component: HowItWorksComponent
  },
  {
    path: 'how-it-works/:id',
    canActivate: [needsLoginGuard],
    component: HowItWorksDetailComponent
  },
  {
    path: 'open',
    canActivate: [needsLoginGuard],
    component: OpenComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent
  },
  {
    path: 'travel-report',
    canActivate: [needsLoginGuard],
    component: TravelReportComponent
  },
  {
    path: 'contract',
    canActivate: [needsLoginGuard],
    component: ContractComponent
  },
  {
    path: 'check-in-adult',
    canActivate: [needsLoginGuard, reservationHasPendingCheckInsGuard],
    component: CheckInFormComponent
  },
  {
    path: 'check-in-minor',
    canActivate: [needsLoginGuard, reservationHasMinorPendingCheckInsGuard],
    component: CheckInFormComponent
  },
  {
    path: 'check-in-signature',
    canActivate: [needsLoginGuard, reservationHasPendingSignedCheckinsGuard],
    component: CheckInSignatureComponent
  },
  {
    path: 'check-in-signature-minor',
    canActivate: [needsLoginGuard, reservationHasMinorPendingSignedCheckinsGuard, reservationHasAdultCompletedCheckinsGuard],
    component: CheckInSignatureMinorComponent
  },
  {
    path: 'check-in-end',
    canActivate: [needsLoginGuard],
    component: CheckInEndComponent
  },
  {
    path: 'check-in-minor-end',
    canActivate: [needsLoginGuard],
    component: CheckInMinorEndComponent
  },
  {
    path: 'check-in-mrz',
    canActivate: [needsLoginGuard],
    component: CheckInMrzComponent
  },
  {
    path: 'others-1',
    canActivate: [needsLoginGuard],
    component: Others1Component
  },
  {
    path: 'others-2',
    canActivate: [needsLoginGuard],
    component: Others2Component
  },
  {
    path: 'plans-and-services',
    canActivate: [needsLoginGuard],
    component: PlansAndServicesComponent
  },
  {
    path: 'map',
    canActivate: [needsLoginGuard],
    component: MapComponent
  },
  {
    path: 'info',
    canActivate: [needsLoginGuard],
    component: InfoComponent
  },
  {
    path: 'deposit/:checkinId',
    canActivate: [needsLoginGuard, reservationHasPendingDepositGuard],
    component: DepositComponent
  },
  {
    path: 'deposit-new-check-in',
    canActivate: [needsLoginGuard, reservationHasPendingDepositGuard],
    component: DepositNewCheckInComponent
  },
  {
    path: 'deposit-select-check-in',
    canActivate: [needsLoginGuard, reservationHasPendingDepositGuard],
    component: DepositSelectCheckInComponent
  },
  {
    path: '**',
    redirectTo: '/home',
    pathMatch: 'full'
  }
];
